const DateFormat = (date) => (
    new Intl.DateTimeFormat('en-GB', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric'
    }).format(new Date(date))
)

export default DateFormat;